import { createStore as createZustandStore } from 'zustand/vanilla';
const DERIVED_KEY_STORAGE_KEY = 'derived-key';
const AUTH_META_STORAGE_KEY = 'auth-meta';
export function createSecretDerivationStore(options) {
    const shouldPersist = options?.persist === true;
    // SecureStorage ref — populated by hydrate(), used by actions for persistence
    let secureStorage = null;
    return createZustandStore()((set, get) => ({
        method: null,
        derivedKey: null,
        loginWallet: null,
        hydrated: !shouldPersist,
        derivationStatus: 'idle',
        derivationMessage: '',
        prfSupport: null,
        credentialVersion: 0,
        setLogin: (method, key) => {
            set({ method, derivedKey: key });
            if (secureStorage) {
                secureStorage.encryptAndStore(DERIVED_KEY_STORAGE_KEY, key).catch(() => { });
                const meta = { method, loginWallet: get().loginWallet };
                secureStorage.setJSON(AUTH_META_STORAGE_KEY, meta).catch(() => { });
            }
        },
        setLoginWallet: (wallet) => {
            set({ loginWallet: wallet });
            if (secureStorage) {
                const method = get().method;
                if (method) {
                    const meta = { method, loginWallet: wallet };
                    secureStorage.setJSON(AUTH_META_STORAGE_KEY, meta).catch(() => { });
                }
            }
        },
        setDerivationStatus: (status) => set({ derivationStatus: status }),
        setDerivationMessage: (message) => set({ derivationMessage: message }),
        setPrfSupport: (result) => set({ prfSupport: result }),
        bumpCredentialVersion: () => set((s) => ({ credentialVersion: s.credentialVersion + 1 })),
        logout: () => {
            // Null the store reference — do NOT zeroize the Uint8Array buffer.
            // In-flight closures (e.g. useRevealSecret mid-reveal) may still hold
            // a reference to the same buffer; mutating it would corrupt their key
            // and could lock user funds. GC will reclaim the buffer once no
            // references remain.
            set({ method: null, derivedKey: null, loginWallet: null });
            if (secureStorage) {
                secureStorage.clear().catch(() => { });
            }
        },
        hydrate: async (storage) => {
            secureStorage = storage;
            try {
                const [derivedKey, meta] = await Promise.all([
                    storage.loadAndDecrypt(DERIVED_KEY_STORAGE_KEY),
                    storage.getJSON(AUTH_META_STORAGE_KEY),
                ]);
                if (derivedKey && meta?.method) {
                    set({
                        method: meta.method,
                        derivedKey,
                        loginWallet: meta.loginWallet ?? null,
                        hydrated: true,
                    });
                    return;
                }
            }
            catch { /* ignore — start fresh */ }
            set({ hydrated: true });
        },
    }));
}
